module.exports = __webpack_public_path__ + "img/coupon-ended.9c99d968.png";